'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$() {
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMake$lzy17 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMakebitmap$17 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_make$lzy17 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_makebitmap$17 = false;
}
export { $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ as $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ };
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$() {
}
export { $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ as $h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ };
$h_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype = $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype;
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMakebitmap$17)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMake$lzy17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMakebitmap$17 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_defaultMake$lzy17;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_makebitmap$17)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_make$lzy17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_makebitmap$17 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$__f_make$lzy17;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$, "app.data.types_drug$package$DrugRequestAcceptedSeen$", ({
  Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeBoolean: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ as $d_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ };
var $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$;
function $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$() {
  if ((!$n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$)) {
    $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ = new $c_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$();
  }
  return $n_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$;
}
export { $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ as $m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedSeen$ };
//# sourceMappingURL=app.data.types_drug$package$-Drug-Request-Accepted-Seen$.js.map
